<div bsModal tabindex="-1" aria-labelledby="pop-up-elo-group" class="body">
  <div>
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          (click)="onClickClose()"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          *ngIf="showCloseButton"
        >
          <span class="icon-close"></span>
        </button>
      </div>
      <div class="container-content">
        <div class="first-section">
          <div>
            <h1>Sua opinião é muito importante para nós</h1>
            <h2>
              Participe da nossa pesquisa e contribua para um produto melhor
            </h2>
            <h3>Leva apenas 10 minutinhos</h3>
            <button class="clear-button" (click)="redirectUser()">Responder Pesquisa</button>
          </div>
        </div>
        <div class="second-section">
          <img
            src="assets/images/elo-group/profile_elo_group.svg"
            alt="profile-elo-group"
            class="profile-elo-group"
          />
        </div>
      </div>
    </div>
  </div>
</div>
